import { render, staticRenderFns } from "./planejamento.vue?vue&type=template&id=1a1c53e0&scoped=true"
import script from "./planejamento.vue?vue&type=script&lang=js"
export * from "./planejamento.vue?vue&type=script&lang=js"
import style0 from "./planejamento.vue?vue&type=style&index=0&id=1a1c53e0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1c53e0",
  null
  
)

export default component.exports